var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    stroke: "#1E232C",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 1.72695V5.54513H11.1816",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9088V8.09067H4.81818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59727 4.90882C2.92002 3.99677 3.46854 3.18135 4.19166 2.53863C4.91478 1.89591 5.78893 1.44685 6.73255 1.23335C7.67616 1.01984 8.65848 1.04885 9.58785 1.31767C10.5172 1.5865 11.3633 2.08636 12.0473 2.77064L15 5.54518M1 8.09064L3.95273 10.8652C4.63666 11.5495 5.48278 12.0493 6.41215 12.3181C7.34152 12.587 8.32384 12.616 9.26745 12.4025C10.2111 12.189 11.0852 11.7399 11.8083 11.0972C12.5315 10.4545 13.08 9.63904 13.4027 8.727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f780089182f2cbc4ea8b685130f77668.svg";
export { ForwardRef as ReactComponent };